export default __webpack_public_path__ + "static/media/web-automation-testing.1996193b.svg";